import { useState } from "react";
import { ChevronUp, Minus, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { brl } from "@/lib/api";
import { cn } from "@/lib/utils";

const Gift = ({ l, v, testId }) => <li className="flex justify-between rounded-md bg-emerald-500/10 px-3 py-2.5 text-sm text-emerald-600 dark:text-emerald-400" data-testid={testId}><span>{l}</span><span>{v}</span></li>;
const Step = ({ onClick, label, testId, children }) => <button type="button" onClick={onClick} aria-label={label} className="grid h-6 w-6 place-items-center rounded border bg-background transition-colors hover:bg-accent" data-testid={testId}>{children}</button>;

function CartItem({ i, setQty }) {
  return (
    <li className="space-y-2 rounded-md bg-muted/60 px-3 py-3 text-sm" data-testid={`order-item-${i.id}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="min-w-0">
          <span className="block leading-tight">{i.name}</span>
          {i.notes && <span className="block text-xs text-amber-600 dark:text-amber-400">Obs: {i.notes}</span>}
        </span>
        <button type="button" onClick={() => setQty(i.key, 0)} aria-label="Remover" className="text-muted-foreground transition-colors hover:text-red-500" data-testid={`order-item-remove-${i.id}`}><Trash2 className="h-4 w-4" /></button>
      </div>
      <div className="flex items-center gap-2 text-muted-foreground">
        <Step onClick={() => setQty(i.key, i.qty - 1)} label="Diminuir" testId={`order-item-dec-${i.id}`}><Minus className="h-3 w-3" /></Step>
        <span data-testid={`order-item-qty-${i.id}`}>{i.qty} x {brl(i.price)}</span>
        <Step onClick={() => setQty(i.key, i.qty + 1)} label="Aumentar" testId={`order-item-inc-${i.id}`}><Plus className="h-3 w-3" /></Step>
        <span className="ml-auto font-semibold text-foreground">{brl(i.price * i.qty)}</span>
      </div>
    </li>
  );
}

export function NewOrderCart({ items, setQty, lo, lmode, freeDel }) {
  if (!items.length && !lo.products.length) return <p className="py-6 text-center text-sm text-muted-foreground" data-testid="order-cart-empty">Carrinho vazio</p>;
  return (
    <ul className="space-y-2" data-testid="order-items-list">
      {items.map((i) => <CartItem key={i.key} i={i} setQty={setQty} />)}
      {lo.products.map((r) => <Gift key={r.id} l={`1x ${r.name} (resgate de pontos)`} v="grátis" />)}
      {freeDel && <Gift l="Entrega grátis com pontos" v={lo.deliveryOff ? `- ${brl(lo.deliveryOff)}` : "taxa zerada"} testId="order-free-delivery" />}
      {lo.off > 0 && <Gift l={lmode === "cashback" ? "Cashback" : "Desconto dos pontos"} v={`- ${brl(lo.off)}`} testId="order-loyalty-discount" />}
    </ul>
  );
}

const Row = ({ l, v, testId }) => <p className="flex justify-between text-sm text-muted-foreground"><span>{l}</span><span data-testid={testId}>{v}</span></p>;

export function CartFooter({ subtotal, fee, off, total, onPay }) {
  const [open, setOpen] = useState(false);
  return (
    <footer className="border-t px-4 pb-4" data-testid="order-cart-footer">
      <button type="button" onClick={() => setOpen((v) => !v)} className="flex w-full justify-center py-2 text-muted-foreground transition-colors hover:text-foreground" aria-label="Ver valores" data-testid="order-summary-toggle">
        <ChevronUp className={cn("h-5 w-5 transition-transform", open && "rotate-180")} />
      </button>
      {open && (
        <div className="mb-3 space-y-1" data-testid="order-summary">
          <Row l="Subtotal" v={brl(subtotal)} testId="order-subtotal" />
          <Row l="Entrega" v={brl(fee)} testId="order-fee" />
          {off > 0 && <Row l="Descontos" v={`- ${brl(off)}`} testId="order-discounts" />}
        </div>
      )}
      <Button onClick={onPay} className="h-14 w-full justify-between rounded-lg px-5 text-base" data-testid="save-order-btn">
        <span className="font-bold">PAGAR <span className="text-xs font-normal opacity-80">(Ctrl + p)</span></span>
        <span className="text-lg font-bold" data-testid="order-total">{brl(total)}</span>
      </Button>
    </footer>
  );
}
